<template>
  <div class="context-list auto-height auto-width">
    <button v-if="context.allowAddColumn" type="button" class="context-link" @click="addColumn">
      {{ $t('Add column') }}
    </button>
    <button
      v-if="context.allowDeleteColumn"
      type="button"
      class="context-link context-link-red"
      @click="deleteColumn"
    >
      {{ $t('Delete column') }}
    </button>
    <template v-if="context.hourlyRateOption">
      <button
        v-if="context.isLabourDivided"
        type="button"
        class="context-link"
        @click="hideHourlyRate"
      >
        {{ $t('Hide hourly rate') }}
      </button>
      <button v-else type="button" class="context-link" @click="showHourlyRate">
        {{ $t('Show hourly rate') }}
      </button>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'EstimateHeaderContext',
    props: {
      context: {
        type: Object,
        default: () => ({
          isLabourDivided: Boolean,
          allowDeleteColumn: Boolean,
          allowAddColumn: Boolean,
          hourlyRateOption: Boolean,

          add: Function,
          delete: Function,
          showHourlyRate: Function,
          hideHourlyRate: Function,
        }),
      },
    },
    methods: {
      addColumn() {
        this.context.add?.();
        this.$emit('close');
      },
      deleteColumn() {
        this.context.delete?.();
        this.$emit('close');
      },
      showHourlyRate() {
        this.context.showHourlyRate?.();
        this.$emit('close');
      },
      hideHourlyRate() {
        this.context.hideHourlyRate?.();
        this.$emit('close');
      },
    },
  };
</script>
